import { useState , useEffect} from "react";
import StatsBox from "../StatsPage/StatsBox.js";
import SubmitInputField from "./submitInputField.js";
import axios from "../../api/axios.js";
import { Buffer } from "buffer";
import Select from "react-select";
import SubmitCreatableSelect from "./SubmitCreatableSelect.js";

export default function MoleculeForm({ molecule, title_text, disabled, onChange, moleculeId_start=null, backgroundColor = "white", tooltips = {
  smiles: "Enter the SMILES of your molecule.",
  name: "Enter the most commonly used name for this molecule. If left empty unnamed intermediate or molecule is used instead.",
  chebi: "If this molecule exists in ChEBI database the ID can be linked. It is recommended to deposit any new molecule to ChEBI as well.",
  marts: "Molecules already in MARTS have Marts ID, fill in only if you want to use a molecule that is already inside the database.",
  stereochemistry: "Select whether the molecule stereochemistry defined by smiles is absolute or relative, if undetermined leave uncertain."
} }) {
  const [isAutoFilled, setIsAutoFilled] = useState(false);

  const [moleculeId, setMoleculeId] = useState(moleculeId_start);

  // The molecule of a row can also be filled in from the outside (e.g. by the
  // "Copy mechanism" dialog), and this component stays mounted through that, so
  // the image id has to follow the prop instead of only its initial value.
  useEffect(() => {
    if (moleculeId_start !== null && moleculeId_start !== undefined) {
      setMoleculeId(moleculeId_start);
    }
  }, [moleculeId_start]);

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    // Propagate the raw edit. If this row was previously auto-filled from MARTS,
    // editing any identifier other than the MARTS ID itself may mean it no longer
    // corresponds to that molecule, so drop the now-stale MARTS ID (and image).
    // The database check below re-fills it if the edited value resolves again.
    const edited = { ...molecule, [name]: value };
    if (isAutoFilled && !disabled && name !== "marts") {
      edited.marts = "";
      setMoleculeId(null);
      setIsAutoFilled(false);
    }
    onChange(edited);

    // Re-resolve against the database from the edited value. On a hit this
    // re-fills every field (including the MARTS ID); on a miss the MARTS stays
    // cleared, so a molecule no longer in MARTS no longer carries a stale ID.
    const result = await checkMoleculeDatabase(name, value);
    if (result) {
      setIsAutoFilled(true);
      setMoleculeId(result.molecule_id);
      onChange(result);
    }
  };

  async function checkMoleculeDatabase(field, value) {
    console.log("Checking database {field, value}:", field, value);
            if (value == "") {
              return null
            }   
            const req = {
              smiles: null,
              martsId:  null,
              chebiId: null,
              name: null,
              stereochemistry: null,
              requestType: "molecule"
            }
            if (field=="smiles"){
              req.smiles = Buffer.from(value)
              req.stereochemistry = molecule.stereochemistry
            }
            else if (field=="name"){
              req.name = value
            }
            else if (field=="marts"){
              if (!/^marts_[ERM][0-9]{5}$/.test(value)) {
                return null;
              }
              req.martsId = value
            }
            else if (field=="chebi"){
              req.chebiId = value
            }
            else if (field=="stereochemistry"){
              if (!molecule.smiles) {
                return null;
              }
              req.stereochemistry = value
              req.smiles = Buffer.from(molecule.smiles)
            }
            
            else{
              return null
            }
            const response = await axios.post("/submitcheck", req);
            if (typeof response.data === 'object' && response.data !== null) {
              return {
                  smiles: response.data.smiles,
                  name: response.data.name,
                  marts: response.data.persistent_id,
                  chebi: response.data.chebi,
                  molecule_id: response.data.molecule_id,
                  stereochemistry: response.data.stereochemistry || "uncertain"
              }
          } else if (typeof response.data === 'string') {
              return null;
          }
    return null;
  }

  return (
    <div>

        <StatsBox title={title_text} backgroundColor={backgroundColor}>
        <SubmitInputField name="smiles" value={molecule.smiles || ""} onChange={handleInputChange} label="SMILES" disabled={disabled} tooltip={tooltips.smiles} placeholder="CC(C)=CCC/C(C)=C/COP(=O)([O-])OP(=O)([O-])[O-]"/>
        <SubmitInputField name="name" value={molecule.name || ""} onChange={handleInputChange} label="Name" disabled={disabled} tooltip={tooltips.name} placeholder="(2E)-GPP" />
        <SubmitInputField name="chebi" value={molecule.chebi || ""} onChange={handleInputChange} label="ChEBI ID" disabled={disabled} tooltip={tooltips.chebi} placeholder="58057"/>
        <SubmitInputField name="marts" value={molecule.marts || ""} onChange={handleInputChange} label="Marts ID" disabled={disabled} tooltip={tooltips.marts} placeholder="marts_M00312"/>
        <SubmitCreatableSelect name="stereochemistry" value={{ value: molecule.stereochemistry || "uncertain", label: molecule.stereochemistry || "uncertain" }} onChange={handleInputChange} label="Stereochemistry" disabled={disabled} target="stereochemistry" options={[
          { value: "absolute", label: "absolute" },
          { value: "relative", label: "relative" }, 
          { value: "uncertain", label: "uncertain" }
        ]} />
        <img key={moleculeId} src={`/mol_${moleculeId}.png`} alt={`${molecule.name}`} style={{ width: "100px", height: "auto" }} onError={(e) => e.target.style.display = 'none' } />
      </StatsBox>
    </div>
  );
}